import React from 'react';

export default function InteractionHeader({ patientName, patientAge, totalActive }) {
  return (
    <header className="bg-white border-bottom p-3 d-flex justify-content-between align-items-center">
      {/* Título en púrpura */}
      <h2 className="mb-0 fw-bold" style={{ color: '#4723C0', fontSize: '1.25rem', fontWeight: 600 }}>
        Visualizador de Interacciones Terapéuticas
      </h2>

      {/* Datos del paciente y badge */}
      <div className="d-flex align-items-center">
        {/* Texto gris */}
        <span className="me-3" style={{ color: '#6B7280', fontSize: '0.875rem' }}>
          Paciente: {patientName} • {patientAge} años
        </span>

        {/* Pills de medicamentos activos */}
        <span
          className="px-3 py-1 rounded-pill text-xs font-medium"
          style={{
            backgroundColor: '#EDE9FE', // púrpura claro
            color: '#4723C0',             // púrpura oscuro
            fontSize: '0.75rem'
          }}
        >
          {totalActive} medicamentos activos
        </span>
      </div>
    </header>
  );
}
